import { makeAutoObservable } from "mobx";
import { PProductConfigCreator } from "./PProductConfigCreator";
import { PProductError } from "./PProductError";
import { PProductUnavailabilityDetails } from "./PProductInstanceUnavailabilityDetails";
export class PProductInstanceCreatorPart {
    constructor(params) {
        this.domain = params.domain;
        this.possibleProductTypes = params.possibleProductTypes;
        this.productType = params.productType;
        this.partConfigCreator = params.partConfigCreator;
        this.restaurant = params.restaurant;
        makeAutoObservable(this);
    }
    static create(params) {
        const productType = params.restaurant.productTypes.get(params.productTypeId);
        const modifierOrder = productType.divisibleModifiersOrder;
        const partConfigCreator = PProductConfigCreator.create({
            domain: params.domain.productConfigCreator,
            restaurant: params.restaurant,
            localizationProvider: params.localizationProvider,
            modifierOrder,
        });
        return new PProductInstanceCreatorPart({
            domain: params.domain,
            productType,
            partConfigCreator,
            possibleProductTypes: params.possibleProductTypes,
            restaurant: params.restaurant,
        });
    }
    get productTypeId() {
        return this.productType.id;
    }
    get productName() {
        return this.productType.name;
    }
    get productBaseIngredients() {
        return this.productType.baseIngredients;
    }
    get productTags() {
        return this.productType.tags;
    }
    get productAllergens() {
        return this.productType.allergens;
    }
    get productPhoto() {
        return this.productType.photo;
    }
    get productDescription() {
        return this.productType.description;
    }
    get productFreeModifierItemsCount() {
        return this.productType.freeModifierItemsCount;
    }
    get productAvailabilityInfo() {
        if (this.productType.availability === "TemporarilyUnavailable") {
            return { type: "TemporarilyUnavailable" };
        }
        const { currentFulfillmentTimes } = this.domain.scope;
        if (this.productType.availabilitySchedule === null ||
            currentFulfillmentTimes === null) {
            return { type: "Available" };
        }
        const scheduleState = this.productType.availabilitySchedule.state(currentFulfillmentTimes);
        return {
            type: "Schedule",
            state: scheduleState,
        };
    }
    get availability() {
        return this.domain.availability;
    }
    get error() {
        if (this.productAvailabilityInfo.type === "TemporarilyUnavailable" ||
            (this.productAvailabilityInfo.type === "Schedule" &&
                this.productAvailabilityInfo.state.available.isDefinitelyFalse)) {
            return PProductError.temporaryUnavailable();
        }
        if (this.availability.isAvailable.isDefinitelyFalse &&
            this.availability.unavailabilityReasons.includes("ProductType")) {
            const { customParametersDetails } = new PProductUnavailabilityDetails({
                availability: this.availability,
                restaurant: this.restaurant,
            });
            return PProductError.unavailable(customParametersDetails);
        }
        return PProductError.none();
    }
    touch() {
        this.partConfigCreator.touch();
    }
}
